import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";
import { Field } from "formik";

import FormikSemanticDropdown from "../../forms/formik/FormikSemanticDropdown.jsx";
import SegmentMessage from "../../forms/messages/SegmentMessage.jsx";

import { PANEL_STATES } from "../../../state/reducers/projectWizard/projectWizardConstants.js";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class RequiredOptionPanel extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    view: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    selected: PropTypes.object,
    options: PropTypes.array.isRequired,

    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    name: "id",
    showValidity: false,
    copyKey: "project_wizard.required_option_panel"
  };

  // -- RENDER --//

  renderActive = () => {
    const { name, options, apiErrors, copyKey, copy } = this.props;

    return (
      <Fragment>
        <Header as="h3" attached="top" block>
          {copy(`${copyKey}.title`)}
        </Header>
        <Segment clearing={true} attached>
          <p>{copy(`${copyKey}.body`)}</p>

          <Field
            name={name}
            label={copy(`${copyKey}.dropdown_label`)}
            placeholder={copy(`${copyKey}.dropdown_placeholder`)}
            options={options}
            required={true}
            apiErrors={apiErrors}
            component={FormikSemanticDropdown}
          />
        </Segment>
      </Fragment>
    );
  };

  renderSet = () => {
    const { selected, copyKey, copy } = this.props;

    if (selected && selected.readonly) {
      return (
        <SegmentMessage
          title={copy(`${copyKey}.messages.already_set_readonly.title`)}
          message={copy(`${copyKey}.messages.already_set_readonly.message`)}
          negative={true}
          style={{ marginTop: "2em" }}
        />
      );
    }

    return null;

    // currently not needed but may be useful once multiregion/multiprovider is in place
    // const { selected, copyKey, copy } = this.props;
    // return (
    //   <Fragment>
    //     <Header as="h3" attached="top" block>
    //       {copy(`${copyKey}.title`)}
    //     </Header>
    //     <Segment clearing={true} attached>
    //       <p>{copy(`${copyKey}.already_set_body`)}</p>
    //       <p>
    //         <strong>{`${selected.name}`}</strong>
    //       </p>
    //     </Segment>
    //   </Fragment>
    // );
  };

  renderInactive = () => {
    return null;
  };

  render() {
    const { view, selected } = this.props;

    switch (view) {
      case PANEL_STATES.ACTIVE:
        if (selected) {
          return this.renderSet();
        } else {
          return this.renderActive();
        }
      default:
        return this.renderInactive();
    }
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(RequiredOptionPanel);
